import React from 'react';
import PropTypes from 'prop-types';

import Google from './Calendars/Google';
import Outlook from './Calendars/Outlook';

export default function Calendars({ calendars }) {
  return (
    <div className="mt-4">
      <h4>Your Social Media Accounts</h4>
      <Google calendars={calendars} />
      <Outlook calendars={calendars} />
    </div>
  );
}

Calendars.propTypes = {
  calendars: PropTypes.object.isRequired,
};
